import Swiper, {Navigation} from 'swiper';


const historyCarousel = (container) => {
    let nextBtn = $('.history').find('.swiper-button-next');

    function updateDarkenSlide(visible){
        if(visible.length > 1) {
            visible.forEach((el, i) => {
                if (i === visible.length - 1) {
                    $(el).addClass('hidden-slide')
                } else {
                    $(el).removeClass('hidden-slide')
                }
            })
        } else {
            visible.forEach((el, i) => {
                $(el).removeClass('hidden-slide')
            })
        }
    }


    if ($(container).length > 0) {

        let slider = new Swiper(container, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 20,
            grabCursor: true,
            loop: false,
            watchSlidesProgress: true,
            loopPreventsSlide: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            breakpoints: {
                1460: {
                    slidesPerView: 3.5,
                    spaceBetween: 80,
                },
                1024: {
                    slidesPerView: 2.5,
                    spaceBetween: 60,
                },
                992: {
                    slidesPerView: 2.2,
                    spaceBetween: 40,
                },
                576: {
                    slidesPerView: 1
                },
            },
            on: {
                init: function () {
                    let visible = this.visibleSlides;
                    updateDarkenSlide(visible);
                },

                slideChange: function () {
                    let last = Math.floor(this.slides.length - this.params.slidesPerView);
                    if(this.activeIndex > last) {
                        this.slideTo(last);
                    }
                },

                slideChangeTransitionStart: function () {
                    let visible = this.visibleSlides,
                        visibleIndexes = this.visibleSlidesIndexes,
                        length = this.slides.length - 1;

                    if(visibleIndexes[visibleIndexes.length - 1] === length) {
                        nextBtn.addClass('swiper-button-disabled');

                    } else {
                        nextBtn.removeClass('swiper-button-disabled');
                    }

                    updateDarkenSlide(visible);
                },
            },
        });
    }
}
export default historyCarousel;